import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Bot, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Ajustes de la IA que responde por el admin en el chat de clientes. */
export const ClientAiSettingsPanel = () => {
  const { authHeader } = useAuth();
  const [cfg, setCfg] = useState(null);

  const load = useCallback(async () => {
    try { setCfg((await axios.get(`${API}/admin/client-ai/settings`, { headers: authHeader() })).data); }
    catch { toast.error("No se pudo cargar la IA del chat"); }
  }, [authHeader]);
  useEffect(() => { load(); }, [load]);

  const save = async (patch) => {
    try {
      const r = await axios.put(`${API}/admin/client-ai/settings`, patch, { headers: authHeader() });
      setCfg(r.data);
      toast.success("IA del chat actualizada");
    } catch { toast.error("No se pudo guardar"); }
  };

  if (!cfg) return <div className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin text-[#d4af37] mx-auto" /></div>;

  return (
    <div className="space-y-4" data-testid="client-ai-settings-panel">
      <div className="rounded-2xl border border-[#d4af37]/30 bg-gradient-to-r from-[#d4af37]/[0.06] to-transparent p-4 flex items-start gap-3">
        <div className="w-11 h-11 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/40 flex items-center justify-center shrink-0"><Bot className="w-5 h-5 text-[#d4af37]" /></div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#d4af37]">IA en el chat de clientes</div>
          <p className="text-[12px] text-neutral-300 mt-1">Responde por ti 24/7 con tono de Cristopher: resuelve dudas de servicios, precios y métodos de pago, muestra botones para registrar el pago y para agendar (sólo cuando ya aprobaste el pago). Se calla automáticamente mientras tú conversas y puedes pausarla por cliente desde cada ventana de chat ("IA on/off").</p>
        </div>
        <div className="flex items-center gap-2">
          <Label className="text-xs text-neutral-300">{cfg.enabled ? "Activa" : "Pausada"}</Label>
          <Switch data-testid="client-ai-enabled" checked={!!cfg.enabled} onCheckedChange={(v) => save({ enabled: v })} />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <Label className="text-xs text-neutral-300 whitespace-nowrap">Minutos de silencio tras tu último mensaje</Label>
        <Input data-testid="client-ai-silence" type="number" min={1} max={240} defaultValue={cfg.silence_min} onBlur={(e) => { const v = Number(e.target.value); if (v && v !== cfg.silence_min) save({ silence_min: v }); }} className="w-24 bg-black/40 border-white/10 text-white" />
      </div>
    </div>
  );
};

export default ClientAiSettingsPanel;
